/*eslint no-unused-vars: "error"*/
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

//import React, { Suspense } from 'react';
//import { useTranslation } from 'react-i18next';

ReactDOM.render(<App />, document.getElementById('root'));
